import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/price-earnings-ratio',
  component: () => import('../../routes/PriceEarningsCalculator.svelte'),
  card: {
    id: 'price-earnings-ratio',
    title: 'P/E Ratio Calculator',
    description: 'Calculate price-to-earnings ratios, PEG ratios, and earnings yield. Compare stock valuations against market benchmarks.',
    icon: 'analytics',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/price-earnings-ratio',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'P/E Ratio Calculator – Stock Valuation & PEG Ratio Calculator',
    description: 'Free P/E ratio calculator to evaluate stock valuations. Calculate trailing and forward P/E, PEG ratio, earnings yield, and dividend yield. Compare against S&P 500, Nasdaq, and sector averages.',
  },
};

export default meta;
